/** FIXME: Refactor this code snippet and split in different sort methods */

/* eslint-disable no-nested-ternary */
const importantOnTop = cancelType => (
  { currentTicket: currentTicketA },
  { currentTicket: currentTicketB },
) => {
  // First, put cancelled orders on top
  // Then compare both tickets 'dueTime'. An earlier 'dueTime' comes first.
  // Then compare both tickets 'modificationTime'. A later 'modificationTime' comes first.
  // Lastly compare both tickets 'id'. A lower 'id' comes first.
  return currentTicketA.type === cancelType && currentTicketB.type !== cancelType
    ? -1
    : currentTicketA.type !== cancelType && currentTicketB.type === cancelType
    ? 1
    : currentTicketA.dueTime < currentTicketB.dueTime
    ? -1
    : currentTicketA.dueTime > currentTicketB.dueTime
    ? 1
    : currentTicketA.modificationTime > currentTicketB.modificationTime
    ? -1
    : currentTicketA.modificationTime < currentTicketB.modificationTime
    ? 1
    : currentTicketA.id < currentTicketB.id
    ? -1
    : currentTicketA.id > currentTicketB.id
    ? 1
    : 0;
};
export default importantOnTop;



// WEBPACK FOOTER //
// ./src/util/orders-sort.js